function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/editor/edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e3a131m62a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/edit (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/edit (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/editor/edit",
    style: {
      clipPath: "url(#e3a131m62a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/editor/edit (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/edit (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.563 18.75H.187A.187.187 0 0 1 0 18.563v-.843a.751.751 0 0 1 .75-.751H18a.751.751 0 0 1 .75.751v.843a.187.187 0 0 1-.187.187zM3.415 15a.79.79 0 0 1-.558-.232.8.8 0 0 1-.2-.322.774.774 0 0 1-.023-.376l.691-3.942A.235.235 0 0 1 3.394 10L13.329.068A.228.228 0 0 1 13.5 0a.231.231 0 0 1 .167.068l3.9 3.9a.235.235 0 0 1 .068.166.232.232 0 0 1-.018.089.228.228 0 0 1-.05.076l-9.945 9.933a.228.228 0 0 1-.122.068l-3.942.692a1.094 1.094 0 0 1-.143.008zM13.5 2.414l-8.5 8.5L4.629 13l2.084-.368 8.5-8.5L13.5 2.414z",
    transform: "translate(2.625 2.625)",
    style: {
      fill: "#7b7b7b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.379e257a3c578ad5cb635bddca7b4718.svg";
export { ForwardRef as ReactComponent };